import { Box, Center, Icon } from "@chakra-ui/react";
import { FC } from "react";
import { LuCircleAlert } from 'react-icons/lu';

export type ErrorProps = {
  message: string;
};

export const Error: FC<ErrorProps> = ({ message }) => {
  return (
    <Box>
      <Center>
        <Icon as={LuCircleAlert} boxSize="2em" color="#36425a" mb="2" />
      </Center>
      <Center width="80%" margin="0 auto" textAlign="center">
        {message}
      </Center>
    </Box>
  );
};
